import { NavBar } from 'components/NavBar/NavBar'
import { setConfirmModal } from 'features/global/globalSlice'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import {
    Button,
    Flex,
    MainHeadline,
    PageFooter,
    PageWrapper,
    Table,
    Th,
    Tr,
} from 'styling/GlobalStyles'
import { Pagination } from 'components/Pagination/Pagination'
import { getParams, handlePagination } from 'utils/helpers'
import { ModalTypes } from 'types/global.interface'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import useQueryPagination from 'hooks/useQueryPagination'
import { clearFuelSuppliers, deleteFuelSupplier, getFuelSuppliers } from 'features/fuelManagement/fuelManagementSlice'
import { FuelSuppliersModal } from './FuelSuppliersModal'
import { Td } from 'components/Td/Td'
import { Options } from 'components/Options/Options'

export const FuelSuppliers = () => {
    const [modal, setModal] = useState({ open: false, value: null })
    const dispatch = useDispatch<AppDispatch>()
    const [params, setParams] = useState<any>(getParams({ location }))
    const { suppliers } = useSelector((store: RootState) => store.fuelManagement)

    useQueryPagination({ fetchFunctions: [getFuelSuppliers], cleanUpFunctions: [clearFuelSuppliers], params })

    const handleRemove = (id: number) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteFuelSupplier(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                    noItems: suppliers.data.length < 2,
                },
                word: 'delete supplier',
            }),
        )
    }


    return (
        <>
            <PageWrapper>
                <NavBar defaultValue={params.q} input placeholder='Search Fuel Suppliers...' setParams={setParams} />
                <Flex between mb='16' >
                    <MainHeadline>Fuel Suppliers</MainHeadline>
                    <Button orange onClick={() => setModal({ open: true, value: null })}>
                        Add Supplier
                    </Button>
                </Flex>
                {!suppliers?.data?.length ? (
                    <NoItems title='Fuel Suppliers' />
                ) : (
                    <Table width='100%' >
                        <Th next>
                            <Td w='19%' noTooltip text='NAME' />
                            <Td w='19%' noTooltip text='PHONE NUMBER' />
                            <Td w='19%' noTooltip text='EMAIL' />
                            <Td w='19%' noTooltip text='ADDRESS' />
                            <Td w='19%' noTooltip text='VAT ID' />
                            <Td w='5%' noTooltip />
                        </Th>
                        {suppliers?.data.map((item) => {
                            return (
                                <Tr key={item.id}>
                                    <Td w='19%' text={item.name || '/'} />
                                    <Td w='19%' text={item.phoneNumber || '/'} />
                                    <Td w='19%' text={item.email || '/'} />
                                    <Td w='19%' text={item.address || '/'} />
                                    <Td w='19%' text={item.vatId || '/'} />
                                    <Td options w='5%' >
                                        <Options item={item} title='Fuel Suppliers' handleRemove={handleRemove} openModal={() => setModal({ open: true, value: item })} />
                                    </Td>
                                </Tr>
                            )
                        })}
                    </Table>
                )}


            </PageWrapper>
            {modal.open &&
                <FuelSuppliersModal value={modal.value} closeModal={() => setModal({ value: null, open: false })} />
            }
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams)}
                    pageCount={Math.ceil(suppliers.totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
